import { Component, OnInit, AfterViewInit, ViewChildren, QueryList, ElementRef } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { PromotionService } from 'src/app/services/promotion.service';
import { DomSanitizer, SafeResourceUrl, SafeUrl } from '@angular/platform-browser';
import 'dotdotdot-js'
@Component({
  selector: 'app-promotion',
  templateUrl: './promotion.component.html',
  styleUrls: ['./promotion.component.scss']
})
export class PromotionComponent implements OnInit, AfterViewInit {
  language = JSON.parse(localStorage.getItem('language'))
  @ViewChildren('dot') dot: QueryList<ElementRef>
  private navigateTo: any
  choiceFromSelect: string
  pageTitle: string

  highlightpromotion: any;
  highlightbenefit: any;

  promotion: any;
  benefit: any;

  promotionDate: any;
  benefitDate: any;

  totalpromotionPage: number;
  totalbenefitPage: number;

  renderpromotion: any;
  renderbenefit: any;

  promotionCurrentPage: number = 1;
  benefitCurrentPage: number = 1;

  flag: any
  
  valueDropdown = [
    {
      id: 1,
      value: this.language.promotiontab1
    },
    {
      id: 2,
      value: this.language.promotiontab2
    },
  ];

  constructor(private route: ActivatedRoute, private _promotionService: PromotionService, private _sanitizer: DomSanitizer) { }

  ngOnInit() {

    this.flag = localStorage.getItem("language_flag")

    this.navigateTo = this.route.params.subscribe(params => {


      if (params['type'] === 'promo') {
        this.choiceFromSelect = params['type']
        this.pageTitle = this.language.promotiontab1;

        this._promotionService.get_promotionList_top3().subscribe(response => {
          this.highlightpromotion = response;
        })


        this._promotionService.get_promotionList_active().subscribe(response => {
          this.promotion = response;
          this.totalpromotionPage = this.setTotalpromotionPage(this.promotion);
          this.setRenderpromotionPerpage(this.promotion);
        })

      } else {
        this.choiceFromSelect = params['type'];
        this.pageTitle = this.language.promotiontab2;


        this._promotionService.get_benefitList_top3().subscribe(response => {
          this.highlightbenefit = response;
        })


        this._promotionService.get_benefitList_active().subscribe(response => {
          this.benefit = response;
          this.totalbenefitPage = this.setTotalbenefitPage(this.benefit);
          this.setRenderbenefitPerpage(this.benefit);
        })

      }

    })
  }

  ngAfterViewInit() {
    this.dot.changes.subscribe(() => {
      this.dot.toArray().forEach(el => {
        $(el.nativeElement).dotdotdot({
          truncate: "letter",
          watch: true,

        })
      })
    })
  }

  ngOnDestroy() {
    this.navigateTo.unsubscribe();
  }

  setTotalpromotionPage(newsList) {
    if (newsList.length <= 6) {
      return 1;
    } else {
      return Math.ceil(newsList.length / 6);
    }
  }

  setTotalbenefitPage(newsList) {
    if (newsList.length <= 6) {
      return 1;
    } else {
      return Math.ceil(newsList.length / 6);
    }
  }

  setRenderpromotionPerpage(newsList) {
    if (newsList === undefined) {
      return null;
    } else {
      this.renderpromotion = newsList.slice(this.promotionCurrentPage * 6 - 6, this.promotionCurrentPage * 6);
    }
  }

  setRenderbenefitPerpage(newsList) {
    if (newsList === undefined) {
      return null;
    } else {
      this.renderbenefit = newsList.slice(this.benefitCurrentPage * 6 - 6, this.benefitCurrentPage * 6);
    }
  }

  changeFormatDate(date) {
    if (date === '') {
      return null;
    } else {
      return this.promotionDate = this._promotionService.changeFormatDate(date);
    }
  }

  date_thai(date) {
    if (date === '') {
      return null;
    } else {
      return this.promotionDate = this._promotionService.date_thai(date);
    }
  }

  setCurrentpromotionPage(event) {
    this.promotionCurrentPage = event;
    this.setRenderpromotionPerpage(this.promotion);
  }

  setCurrentbenefitPage(event) {
    this.benefitCurrentPage = event;
    this.setRenderbenefitPerpage(this.benefit);
  }

  getBackground(image) {
    return this._sanitizer.bypassSecurityTrustStyle(`url(${image})`);
  }

  selectValue(event) {

    if (event == 1) {
      this.choiceFromSelect = 'promo'
      this._promotionService.get_promotionList_top3().subscribe(response => {
        this.highlightpromotion = response;
      })

      this._promotionService.get_promotionList_active().subscribe(response => {
        this.promotion = response;
        this.totalpromotionPage = this.setTotalpromotionPage(this.promotion);
        this.setRenderpromotionPerpage(this.promotion);
      })
    } else if (event == 2) {
      this.choiceFromSelect = 'non-promo'
      this._promotionService.get_benefitList_top3().subscribe(response => {
        this.highlightbenefit = response;
      })


      this._promotionService.get_benefitList_active().subscribe(response => {
        this.benefit = response;
        this.totalbenefitPage = this.setTotalbenefitPage(this.benefit);
        this.setRenderbenefitPerpage(this.benefit);
      })
    }

  }

}
